<template>
  <div v-bind:class="{row: !inner}">

    <div  v-loading="loading" element-loading-spinner="qc-spinner" class="invoice col-sm-12 card">
      <div>
        <div class="card-content">
          <div class="row">
            <div class="invoice-lg pull-right text-right">
              <h1>Invoice</h1>
            </div>
            <div class="col-xs-6">
              <img src="static/img/qc/QC-Logo-1.png" style="width: 50%;" /><br/>
              <div class="invoice-sm">
                <h1>Invoice</h1>
              </div>
              <b>Qualification Check Limited</b><br/>
              Company No. 06097472<br/>
              VAT ID 911945229<br/>
              Temple Chambers, 3-7 Temple Avenue<br/>
              London England EC4Y 0DT<br/>
              United Kingdom<br/>
            </div>
          </div>
          <br/>
          <div v-if="invoice" class="row">
            <div class="col-xs-6">
              Customer</br>
              <b>{{invoice.company.name}}</b><br/>
              <span v-if="invoice.company.vatId">VAT ID {{invoice.company.vatId}}<br/></span>
              <span v-if="invoice.company.addressStreet1">{{invoice.company.addressStreet1}}<br/></span>
              <span v-if="invoice.company.addressStreet2">{{invoice.company.addressStreet2}}<br/></span>
              <span v-if="invoice.company.addressStreet3">{{invoice.company.addressStreet3}}<br/></span>
              <span v-if="invoice.company.addressCity">{{invoice.company.addressCity}}</span>
              <span v-if="invoice.company.addressPostCode">{{invoice.company.addressPostCode}}<br/></span>
              <span v-if="invoice.company.addressCountry.name">{{invoice.company.addressCountry.name}}<br/></span>
            </div>
            <div class="invoice-lg col-xs-6 pull-right text-right">
              <div class="row"><span class="col-sm-8">Invoice Date</span><span class="col-sm-4" style="padding-right: 0">{{formatDate(invoice.created)}}</span></div>
              <div class="row"><span class="col-sm-8">Invoice #</span><span class="col-sm-4" style="padding-right: 0">{{invoice.id}}</span></div>
              <div class="row"><span class="col-sm-8">Receipt Id</span><span class="col-sm-4" style="padding-right: 0">{{invoice.receiptId}}</span></div>
              <div class="row"><span class="col-sm-8">Transaction Id</span><span class="col-sm-4" style="padding-right: 0">{{invoice.providerId}}</span></div>
            </div>
          </div>
          <div v-if="invoice" class="invoice-sm row">
            <br/>
            <div class="col-sm-12">
              <div class="row"><span class="col-xs-3">Invoice Date</span><span class="col-xs-2 text-right" style="padding-right: 0">{{formatDate(invoice.created)}}</span></div>
              <div class="row"><span class="col-xs-3">Invoice #</span><span class="col-xs-2 text-right" style="padding-right: 0">{{invoice.id}}</span></div>
              <div class="row"><span class="col-xs-3">Receipt Id</span><span class="col-xs-2 text-right" style="padding-right: 0">{{invoice.receiptId}}</span></div>
              <div class="row"><span class="col-xs-3">Transaction Id</span><span class="col-xs-2 text-right" style="padding-right: 0">{{invoice.providerId}}</span></div>
            </div>
          </div>
          <br/>          
          <div v-if="invoice" class="row noprint">
            <el-table class="table table-striped table-no-bordered"
                ref="invoiceTable"
                :data="tableItems"
                style="width: 100%"
                tooltip-effect="light">
              <el-table-column :min-width="300" :show-overflow-tooltip="true" label="Item">
                <template slot-scope="props">
                  <span v-if="!props.row.calc">
                    <div v-if="props.row.candidateName">
                      <div><strong>{{props.row.candidateName}}</strong></div>
                      <div v-for="name in props.row.instituteNames">{{name}}</div>
                    </div>
                    <div v-else-if="props.row.instituteNames">
                      <div v-for="name in props.row.instituteNames"><strong>{{name}}</strong></div>
                      <div>Accreditation</div>
                    </div>
                    <span v-else>{{props.row.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="onlyExactCredit ? '' : 'Our Price'" :width="125"  min-width="75" align="right" header-align="right">
                <template slot-scope="props">
                  <span v-if="!props.row.calc && props.row.name == 'Exact Credit Amount'"></span>
                  <span v-else-if="!props.row.calc">{{formatMoney(props.row.price)}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="onlyExactCredit ? '' : 'Institute Surcharge'" :width="175" min-width="130" align="right" header-align="right">
                <template slot-scope="props">
                  <span v-if="!props.row.calc && props.row.name == 'Exact Credit Amount'"></span>
                  <span v-else-if="!props.row.calc">{{formatMoney(props.row.surcharge)}}</span>
                  <span v-else>{{props.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Total" :width="100" min-width="75" align="right" header-align="right">
                <template slot-scope="props">
                  <span v-if="!props.row.calc">{{formatMoney(props.row.total)}}</span>
                  <span v-else>
                    {{formatMoney(props.row.value)}}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="invoice" class="row onlyprint">
            <table style="width: 100%">
              <colgroup>
                <col width="65%">
                <col width="10%">
                <col width="15%">
                <col width="10%">
              </colgroup>
              <thead>
                <tr>
                  <th>Item</th>
                  <th style="text-align: right">{{onlyExactCredit ? '' : 'Our Price'}}</th>
                  <th style="text-align: right">{{onlyExactCredit ? '' : 'Institute Surcharge'}}</th>
                  <th style="text-align: right">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in tableItems">
                  <td>
                    <span v-if="!item.calc">
                      <div v-if="item.candidateName">
                        <div><strong>{{item.candidateName}}</strong></div>
                        <div v-for="name in item.instituteNames">{{name}}</div>
                      </div>
                      <span v-else>{{item.name}}</span>
                    </span>
                  </td>
                  <td style="text-align: right">
                    <span v-if="!item.calc && item.name == 'Exact Credit Amount'"></span>
                    <span v-else-if="!item.calc">{{formatMoney(item.price)}}</span>
                  </td>
                  <td style="text-align: right">
                    <span v-if="!item.calc && item.name == 'Exact Credit Amount'"></span>
                    <span v-else-if="!item.calc">{{formatMoney(item.surcharge)}}</span>
                    <span v-else>{{item.name}}</span>
                  </td>
                  <td style="text-align: right">
                    <span v-if="!item.calc">{{formatMoney(item.total)}}</span>
                    <span v-else>
                      {{formatMoney(item.value)}}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 card card-plain">
      <button @click.prevent="print" class="btn btn-fill btn-wd pull-right"><span class="btn-label"><i class="fa fa-print"></i>&nbsp;Print</span></button>
    </div>
    
  </div>
</template>

<style>
.invoice {

}


</style>

<script>
  import moment from 'moment'
  import accounting from 'accounting'

  accounting.settings.currency.symbol = "£";
  
  export default {
    name: "invoice",
    components: {
      
    },
    props: {
      id: String,
      inner: Boolean
    },
    data () {
      return {
        loading: true,
        invoice: null
      }
    },
    mounted: function () {
      this.loading = true
      this.$api.getInvoice(this.id)
        .then(response => {
          this.invoice = response.data
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    computed: {
      tableItems() {
        var items = []

        if(this.invoice) {
          this.invoice.items.forEach(item => {
            item.calc = false
            items.push(item)
          })

          if(items.length > 1) {
            items.push({
              name: "Sub Total",
              calc: true,
              value: this.requestTotal
            })
          }
          if(this.invoice.vatMultiplier > 1) {
            items.push({
              name: "Plus VAT",
              calc: true,
              value: this.vat(this.requestTotal)
            })
          }

          if(this.currentCredit > 0) {
            items.push({
              name: "Less Current Credit",
              calc: true,
              value: this.currentCredit
            })
          }

          items.push({
            name: "Total",
            calc: true,
            value: this.invoice.total
          })

          if(this.fees > 0) {
            items.push({
              name: "Plus Card Fees",
              calc: true,
              value: this.fees
            })

            items.push({
              name: "Total Paid",
              calc: true,
              value: this.paid
            })
          }
        }

        return items
      },
      onlyExactCredit() {
        var only = true
        if(this.invoice != null) {
          this.invoice.items.forEach(item => {
            if(item.name != 'Exact Credit Amount') {
              only = false
            }
          })
        }
        return only
      },
      requestTotal () {
        if(this.invoice != null) {
          var total = 0
          this.invoice.items.forEach(item => {
            total += item.total
          })
          return total
        } else {
          return 0
        }
      },
      currentCredit () {
        if(this.invoice != null) {
          return this.requestTotal + this.vat(this.requestTotal) - this.invoice.total
        } else {
          return 0
        }
      },
      fees () {
        if(this.invoice != null) {
          return this.invoice.paid - this.invoice.total
        } else {
          return 0
        }
      },
    },
    methods: {
      print() {
        window.print()
      },
      vat (amount) {
        if(this.invoice != null) {
          return amount * (this.invoice.vatMultiplier - 1)
        } else {
          return 0
        }
      },
      formatMoney(amount) {
        return accounting.formatMoney(amount)
      },
      formatDate(date) {
        return moment(date).format('DD MMM YYYY')
      }
    }
  }
</script>